export default __webpack_public_path__ + "static/floor2-slide-2-01e97f2d12eb1329ec5596deb9b132f6.jpg";